import { gql } from '@apollo/client';

export const WPS_SAVE_PAYMENT = gql`
  mutation wSavePmntContext($uid: UUID!, $wpsPaymentData: Object!) {
    wSavePmntContext(uid: $uid, wpsPaymentData: $wpsPaymentData)
  }
`;
